/**
 * What the store's `zoomToPointIn2D` action answers (store/index.js), so a caller can say what happened
 * instead of only the toast the action shows:
 *   STARTED     the 2D view is opening on the level's plan (`levelName`, `planUrn`); its callback runs once
 *               the plan is there
 *   NO_LEVEL    no level holds the point, or the level has no plan ("No Level found for the selected item.")
 *   NOT_MAPPED  the plan is not mapped to the 3D model yet ("Level not mapped, …")
 * No imports, so `npm run test:unit` (node --test) can load it directly.
 */
export const PLAN_ZOOM_STATUS = Object.freeze({
  STARTED: 'started',
  NO_LEVEL: 'no-level',
  NOT_MAPPED: 'not-mapped',
});

/**
 * Is `level`'s own plan mapped to the 3D model (its MappingViewersInfo has both corners)? The level
 * zoomToPointIn2D is about to open, not the one selected before it.
 * @param {object|null} level a ForgeLevel
 */
export function isLevelMapped(level) {
  const mapping = level && level.mappingViewersPointsInfo;
  return !!mapping && typeof mapping.isReady === 'function' && mapping.isReady();
}
